import { render, staticRenderFns } from "./LearningGoalsForBlock.vue?vue&type=template&id=17356a96&"
import script from "./LearningGoalsForBlock.vue?vue&type=script&lang=js&"
export * from "./LearningGoalsForBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports